import { ApiResponse } from 'apisauce';
import { useHistory } from 'react-router-dom';
import useHandleApiError from '../../../hooks/useHandleApiError';
import useMoney from '../../../hooks/useMoney';
import LangEnum from '../../../lang/LangEnum';
import { acceptSuggestion } from '../../../services/modules/orders/orders.repository';
import snackbarStore from '../../../stores/Snackbar.store';
import { useTranslation } from '../../translation/TranslationContext';
import { IConfirmAcceptOrderData } from '../accept-suggestion-order/types/acceptSuggestionOrder.types';
import { useOrderActionsContext } from '../contexts/OrderActions.context';
import { ConditionValidationErrors } from '../order.types';
import { transformUpdateResponse } from '../ordersUtils';

const { handleMessage } = snackbarStore;

interface IUseAcceptSuggestedOrder {
  onClose: () => void;
}

export const useAcceptSuggestedOrder = ({ onClose }: IUseAcceptSuggestedOrder) => {
  const { translate } = useTranslation();
  const { getApiErrorMessage } = useHandleApiError();
  const { getCurrencySymbol, formatMoney } = useMoney();
  const { orderRaw } = useOrderActionsContext();
  const history = useHistory();

  type ResponseProps = ApiResponse<
    void,
    {
      message: ConditionValidationErrors;
    }
  >;

  const validateErrors = (response: ResponseProps) => {
    if (response.data && response.data.message && Array.isArray(response.data.message)) {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.SUGGESTED_ORDER_ACCEPT_SUGGESTION_ERROR_MESSAGE, {
          reason: transformUpdateResponse(
            response.data.message.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.messageCode === item.messageCode),
            ),
            formatMoney,
            translate,
            getCurrencySymbol(),
          ),
        }),
      });
    } else {
      const reason = getApiErrorMessage(response, '-');
      handleMessage({
        type: 'error',
        message: translate(LangEnum.SUGGESTED_ORDER_ACCEPT_SUGGESTION_ERROR_MESSAGE, {
          reason,
        }),
      });
    }
  };

  const acceptedSuggestedOrder = async (data: IConfirmAcceptOrderData) => {
    const response = await acceptSuggestion(data, orderRaw?.orderId);

    if (!response.ok) {
      validateErrors(response);
      onClose();
      return;
    }

    handleMessage({
      type: 'success',
      message: translate(LangEnum.SUGGESTED_ORDER_ACCEPT_SUGGESTION_SUCCESS_MESSAGE),
    });
    onClose();
    history.push('/orders');
  };

  return {
    acceptedSuggestedOrder,
  };
};
